(function () {
  var selector = '[data-nnom-account-link]';

  function resetLink(link) {
    link.removeAttribute('data-navigation-pending');
    link.setAttribute('aria-busy', 'false');
    link.classList.remove('is-navigating');
  }

  function resetAllLinks() {
    document.querySelectorAll(selector).forEach(resetLink);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest(selector) : null;

    if (!link || event.defaultPrevented) return;

    if (link.getAttribute('data-navigation-pending') === 'true') {
      event.preventDefault();
      return;
    }

    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.target === '_blank'
    ) {
      return;
    }

    link.setAttribute('data-navigation-pending', 'true');
    link.setAttribute('aria-busy', 'true');
    link.classList.add('is-navigating');

    window.setTimeout(function () {
      resetLink(link);
    }, 10000);
  });

  window.addEventListener('pageshow', resetAllLinks);
})();
